import { getAllGarages } from '$app/common/api';
import { api } from '$app/api';
import { generateGarageSlug } from '../../utils/slug';

export async function getExistingGarageSlugs() {
  const garages = await getAllGarages(true, false);
  return garages.map((garage) => garage.slug).filter(Boolean);
}

export async function prepareGarageCreatePayload(values) {
  const existingSlugs = await getExistingGarageSlugs();
  const slug = generateGarageSlug(values.businessName, values.city, existingSlugs);

  return slug ? {
    ...values,
    slug,
  } : values
}

export function createGarage(data) {
  return api.post(`/garages`, data).then((res) => res.data);
}

export default createGarage;
